import * as React from 'react';

const CatalogIcon = (props) => (
    <svg width={32} height={32} fill="none" {...props}>
        <path
            stroke="#7D61A7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M12 4H5.333C4.597 4 4 4.597 4 5.333V12c0 .736.597 1.333 1.333 1.333H12c.736 0 1.333-.597 1.333-1.333V5.333C13.333 4.597 12.736 4 12 4ZM26.667 4H20c-.736 0-1.333.597-1.333 1.333V12c0 .736.597 1.333 1.333 1.333h6.667c.736 0 1.333-.597 1.333-1.333V5.333C28 4.597 27.403 4 26.667 4ZM26.667 18.667H20c-.736 0-1.333.597-1.333 1.333v6.667c0 .736.597 1.333 1.333 1.333h6.667c.736 0 1.333-.597 1.333-1.333V20c0-.736-.597-1.333-1.333-1.333ZM12 18.667H5.333C4.597 18.667 4 19.264 4 20v6.667C4 27.403 4.597 28 5.333 28H12c.736 0 1.333-.597 1.333-1.333V20c0-.736-.597-1.333-1.333-1.333Z"
        />
    </svg>
);
export default CatalogIcon;
